import moment from 'moment'

export default () => [
  {
    property: 'timestamp',
    header: {
      label: 'TimeStamp'
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => moment(rowData.timestamp).format('MMM Do, YYYY hh:mm:ss.SSS A')]
    }
  },
  {
    property: 'correlationId',
    header: {
      label: 'Correlation ID'
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => rowData.correlationId]
    }
  },
  {
    property: 'message',
    header: {
      label: 'Message'
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => rowData.message]
    }
  }
]
